/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
import { Button, Stack, TextField, Typography } from '@mui/material';

import CustomAutocomplete from 'src/components/custom-autocomplete/custom-autocomplete';
import { useResponsive } from 'src/hooks/use-responsive';

import { useFilter } from './filter.hook';

export interface FilterProps {
  title: string;
  getData: (filters?: any) => void;
  handleAddNew: () => void;
}

export default function Filter({ title, getData, handleAddNew }: FilterProps) {
  const { statusOptions, handleSelectStatus, onSearch } = useFilter(getData, title);

  const responsive = useResponsive;
  const isXs = responsive('down', 'sm');
  const isMd = responsive('down', 'lg');

  return (
    <div data-testid="filter-render-test">
      <Stack alignItems="center" direction={isMd ? 'column' : 'row'} spacing={2} width="100%">
        <Stack direction="row" justifyContent="space-between" alignItems="center" width={isMd ? '100%' : '40%'}>
          <Typography typography="bold-hd-xs" width={isMd ? '60%' : '100%'}>
            {title}
          </Typography>
          {isMd && (
            <Button variant="text" color="primary" onClick={handleAddNew}>
              <Typography typography="bold-bd-md">Adicionar Novo</Typography>
            </Button>
          )}
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          flexWrap={isMd ? 'wrap' : 'nowrap'}
          width={isMd ? '100%' : '60%'}
          justifyContent={isMd ? 'flex-start' : 'flex-end'}
          alignItems="center"
        >
          <TextField
            fullWidth={!!isXs}
            sx={{ minWidth: 270 }}
            placeholder="Busque a Promoção/Campanha desejada"
            onChange={(e) => onSearch(e.target.value)}
            InputProps={{
              sx: { borderRadius: 100 },
            }}
            inputProps={{
              style: { padding: '8px 16px' },
            }}
          />
          <CustomAutocomplete
            handleSelectOption={handleSelectStatus}
            options={statusOptions}
            placeholder="Status"
            disableCloseOnSelect
            sx={{ '.MuiOutlinedInput-root': { p: 0 }, minWidth: 120 }}
          />
        </Stack>
        {!isMd && (
          <Button variant="text" color="primary" onClick={handleAddNew}>
            <Typography typography="bold-bd-md">Adicionar Novo</Typography>
          </Button>
        )}
      </Stack>
    </div>
  );
}
